import Permissions from '@/app/permissions/Permissions';
import MerchantPermissions from '@/app/permissions/MerchantPermissions';

/**
 *
 * @param userPermissions
 * @param isDivided
 * @returns {object}
 */
function getPermissionsByCategories(userPermissions, isDivided = false) {

    const getList = () => {
        const allPermissions = { ...Permissions, ...MerchantPermissions };
        const res = {};

        return userPermissions ? Object.values(allPermissions).reduce(
            (modules, { name, module: moduleName }) => {
                if (userPermissions.includes(name) && moduleName) {
                    modules[moduleName] = [...(modules[moduleName] || []), name].sort();
                }
                return modules;
            },
            res
        ) : null;
    };

    const permissionsList = Object.entries(getList() ?? {});
    const column1 = permissionsList?.slice(0, Math.ceil(permissionsList.length / 2));
    const column2 = permissionsList?.slice(Math.ceil(permissionsList.length / 2));
    return isDivided ? [{ id: 'col-1', col: column1 }, { id: 'col-2', col: column2 }] : permissionsList;
}

export default getPermissionsByCategories;